<template>
    <div>
        <ToolBarNav/>
        <v-container v-if="this.$route.name == 'member'" class="text-center" fill-height style="height: calc(100vh - 58px);">
            <v-row align="center">
            <v-col>
                <p>This is not the route you are looking for...</p>
                <p><i class="fa fa-jedi" style="font-size: 32px;"></i></p>
                <v-btn :to="{name: 'dashboard'}" color="primary" outlined>Get me back home!</v-btn>
            </v-col>
            </v-row>
        </v-container>
        <router-view></router-view>
    </div>
</template>

<script>
import ToolBarNav from '@components/navigation/Navigation.vue';

export default {
    name: 'Member',
    components: {
        ToolBarNav,
    },
    data(){
        return {
            //
        }
    },
    beforeCreate() {
        if(!this.$store.getters['auth/hasLoadedOnce'] && this.$store.getters['auth/isAuthenticated']){
            this.$store.dispatch('user/userRequest')
            .then((resp) => {
                // console.log(resp)
            })
            .catch((err) => {
                this.$router.push({ name: 'login'});
                // console.log(err);
            });
        }
    },
}
</script>

<style scoped>

</style>
